import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Styles.css';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { apiFetch } from './api';

const FeedbackPage = () => {
    const baseUrl = window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000/orders/api';
    const [searchParams] = useSearchParams();
    const [dropdown1, setDropdown1] = useState('');
    const [dropdown2, setDropdown2] = useState('');
    const [dropdown3, setDropdown3] = useState('');
    const [dropdown4, setDropdown4] = useState('');
    const [personalText, setPersonalText] = useState('');
    const maxChars = 512;
    const options = Array.from({ length: 10 }, (_, i) => i + 1);
    const originalSearch = searchParams.toString();
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        const feedback = {
            question_1_rating: parseInt(dropdown1) || null,
            question_2_rating: parseInt(dropdown2) || null,
            question_3_rating: parseInt(dropdown3) || null,
            question_4_rating: parseInt(dropdown4) || null,
            additional_comments: personalText || null
        };
        try {
            const response = await apiFetch(`${baseUrl}/feedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(feedback)
            });
            if (!response.ok) {
                let errorMsg = 'Error submitting feedback';
                try {
                    const errorJson = await response.json();
                    errorMsg = errorJson.detail || errorMsg;
                } catch {
                    const errorText = await response.text();
                    errorMsg = errorText || errorMsg;
                }
                throw new Error(errorMsg);
            }
            navigate(`/?${originalSearch}`);
            window.scrollTo(0, 0);
        } catch (error) {
            setErrorMessage(error.message || 'Unknown error occurred');
        }
    };

    return (
        <>
            <Navbar />
            <main style={{ minHeight: '2vh', padding: '2em', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFFFFF' }}>
                <h1>Feedback</h1>
                <form style={{ display: 'flex', flexDirection: 'column', gap: '1em', alignItems: 'center', width: '90vw', backgroundColor: '#FFFFFF' }} onSubmit={handleSubmit}>
                    <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>How did you like the breakfast order overall?:</p>
                    <label>
                        <select value={dropdown1} onChange={e => setDropdown1(e.target.value)}>
                            <option value="">Please Choose</option>
                            {options.map(num => (
                                <option key={num} value={num}>{num}</option>
                            ))}
                        </select>
                    </label>
                    <span style={{ marginLeft: '1em', fontSize: '0.9em', color: '#555' }}>
                        Please rate from 1 (very bad) to 10 (excellent)
                    </span>
                    <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>How easy was it to place the order?:</p>
                    <label>
                        <select value={dropdown2} onChange={e => setDropdown2(e.target.value)}>
                            <option value="">Please Choose</option>
                            {options.map(num => (
                                <option key={num} value={num}>{num}</option>
                            ))}
                        </select>
                    </label>
                    <span style={{ marginLeft: '1em', fontSize: '0.9em', color: '#555' }}>
                        Please rate from 1 (very difficult) to 10 (very easy)
                    </span>
                    <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Do you like the menu selection?:</p>
                    <label>
                        <select value={dropdown3} onChange={e => setDropdown3(e.target.value)}>
                            <option value="">Please Choose</option>
                            {options.map(num => (
                                <option key={num} value={num}>{num}</option>
                            ))}
                        </select>
                    </label>
                    <span style={{ marginLeft: '1em', fontSize: '0.9em', color: '#555' }}>
                        Please rate from 1 (I do not like the menu selection) to 10 (I love the menu selection)
                    </span>
                    <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Did your meal suit your taste?:</p>
                    <label>
                        <select value={dropdown4} onChange={e => setDropdown4(e.target.value)}>
                            <option value="">Please Choose</option>
                            {options.map(num => (
                                <option key={num} value={num}>{num}</option>
                            ))}
                        </select>
                    </label>
                    <span style={{ marginLeft: '1em', fontSize: '0.9em', color: '#555' }}>
                        Please rate from 1 (I do not like the taste) to 10 (I love the taste)
                    </span>
                    <div style={{ width: '80%', maxWidth: '1000px', height: '30vh', maxHeight: '40vh', marginTop: '1em', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <span style={{ fontSize: '0.9em', color: '#555' }}>
                            {maxChars - personalText.length} characters left
                        </span>
                        <textarea
                            value={personalText}
                            onChange={e => {
                                if (e.target.value.length <= maxChars) setPersonalText(e.target.value);
                            }}
                            maxLength={maxChars}
                            rows={4}
                            style={{ width: '100%', fontSize: '1em', marginTop: '0.5em', resize: 'vertical', height: '100%', padding: '10px' }}
                            placeholder="Personal Feedback (max. 512 characters)"
                        />
                    </div>
                    {errorMessage && (
                        <div style={{ color: 'red', margin: '1em 0', fontWeight: 'bold' }}>
                            {errorMessage}
                        </div>
                    )}
                    <div className="button-2-column">
                        <Link
                            to={`/?${originalSearch}`}
                            className="selection-link"
                            onClick={() => window.scrollTo(0, 0)}
                        >
                            CONTINUE ORDERING
                        </Link>
                        <button
                            type="submit"
                            className={`selection-btn`}
                        >
                            SUBMIT FEEDBACK
                        </button>
                    </div>
                </form>
            </main>
            <Footer />
        </>
    );
};

export default FeedbackPage;